import { useContext } from 'react';
import StatusCard from '@/home/OrderStatusCard';
import { PURCHASE_IN_PROGRESS_FEED_ITEMS } from '~/constants/home';
import { useIsLoggedIn } from '~/context/common/UserContext';
import NextBestActionContext from '~/context/home/NextBestActionContext';
import { FinanceCard, TradeCard } from './Cards';
import {
  FinanceTradeWrapper,
  GridWrapper,
  HeroFavoriteAndSearchCard
} from './HeroCardsReturnUser.styles';
import { SRPLinks, VDPLinks } from './LinkCards';

export default function HeroCardsReturnUser() {
  const {
    actions: { data, isLoaded }
  } = useContext(NextBestActionContext);
  const feedItems = data?.feedItems ?? [];
  const isLoggedIn = useIsLoggedIn();
  const shouldShowPurchaseCard =
    isLoggedIn &&
    (!isLoaded ||
      feedItems.some(item =>
        PURCHASE_IN_PROGRESS_FEED_ITEMS.includes(item.type)
      ));

  const negativeTopMargin = isLoggedIn
    ? 'mt-[-35px]'
    : 'mt-[-65px] m:mt-[-35px]';

  //Large break point moved to 1200px so that text is not wrapped and truncated as much
  return (
    <div className="flex w-full justify-center bg-white">
      <div className="flex w-full flex-col gap-40 px-24 m:max-w-[1056px] l:max-w-[1272px] xl:px-0">
        <GridWrapper
          showPurchase={shouldShowPurchaseCard}
          negativeTopMargin={negativeTopMargin}
          data-qa="link-card-container"
        >
          {shouldShowPurchaseCard ? (
            <StatusCard />
          ) : (
            <>
              <HeroFavoriteAndSearchCard>
                <VDPLinks />
              </HeroFavoriteAndSearchCard>
              <HeroFavoriteAndSearchCard>
                <SRPLinks />
              </HeroFavoriteAndSearchCard>
            </>
          )}
          <FinanceTradeWrapper showPurchase={shouldShowPurchaseCard}>
            <FinanceCard />
            <TradeCard />
          </FinanceTradeWrapper>
        </GridWrapper>
      </div>
    </div>
  );
}
